'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Root = exports.Root = (0, _systemComponents2.default)({
  fontFamily: 'sans'
}, 'fontFamily', {
  '& *': {
    boxSizing: 'border-box'
  }
}, 'space', 'color');

Root.displayName = 'Root';

exports.default = Root;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Root.js
// module id = 86
// module chunks = 35783957827783 162898551421021